export enum RegexOptionsEnum {
    "Ignore Case" = 1,
    "Extended"=2,
    "Ignore Case and Extended"=3,
    "Multiline"=4,   
   "Ignore Case and Multiline"=5,   
   "Multiline and Extended"=6,
   "Ignore Case, Multiline, and Extended"=7
  }